import React, { useEffect } from 'react'
import { useCodeOfConduct } from '../../Hooks/Features/CodeOfConduct/useCodeOfConduct'
import { SkeletonDataTable } from '../Loader/Loader';
import { AgGridReact } from '@ag-grid-community/react';
import { useCommon } from '../../Hooks/Common/useCommon';

const CodeOfConductList = () => {
    const { columnDefs, loader, getCodeOfConductList, gridRef, listData, tagRef } = useCodeOfConduct();
    const { checkPermission } = useCommon();

    useEffect(() => {
        getCodeOfConductList()
    }, []);

    return (
        <div ref={() => checkPermission("welcomekit", tagRef)}>
            <div ref={tagRef} id='{"tabname": "welcomekit", "data": "code_of_conduct_list_tab"}'>
                <div style={{ height: "50vh" }} className="ag-theme-alpine">
                    {loader ? <SkeletonDataTable numSkeletons={12} /> :
                        <AgGridReact
                            rowData={listData}
                            columnDefs={columnDefs}
                            rowHeight={30}
                            headerHeight={40}
                            ref={gridRef} />
                    }
                </div>
            </div>
        </div>
    )
}

export default CodeOfConductList